import { Route, Routes, useLocation, Navigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import WelcomeLaunch from "../../pages/WelcomeLaunch";
import NotFound from "../../pages/web/NotFound";
import Home from "../../pages/Home";
import Vedikshha from "../../pages/Vedikshha";
import ContactPage from "../../pages/ContactPage";
import AboutUs from "../../pages/web/AboutUs";
import Service from "../../pages/web/Service";
import OurWork from "../../pages/web/OurWork";
import Gallary from "../../pages/Gallary";

const AppRoutes = () => {
  const location = useLocation();
  // const [isLaunched, setIsLaunched] = useState(false);

  // useEffect(() => {
  //   const hasLaunched = localStorage.getItem('vcl_launched');
  //   if (hasLaunched === 'true') {
  //     setIsLaunched(true);
  //   }
  // }, []);

  // const handleLaunch = () => {
  //   setIsLaunched(true);
  //   localStorage.setItem('vcl_launched', 'true');
  // };

  // if (!isLaunched && location.pathname === '/') {
  //   return <WelcomeLaunch onLaunch={handleLaunch} />;
  // }

  return (
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/vedikshha" element={<Vedikshha/>} />
      <Route path="/about-us" element={<AboutUs/>} />
      <Route path="/service" element={<Service/>} />
      <Route path="/our-work" element={<OurWork/>} />
      <Route path="/gallary" element={<Gallary/>} />
      <Route path="/contact" element={<ContactPage/>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;